// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1u-6";
export var headerCell = "_1u-2";
export var rowWrapper = "_1u-4";
export var stickyAggregationCell = "_1u-a";
export var stickyAggregationRow = "_1u-7";
export var stickyColumnCell = "_1u-9";
export var stickyColumnHeaderCell = "_1u-8";
export var table = "_1u-1";
export var virtualRowWrapper = "_1u-5";
export var virtualTableContainer = "_1u-0";
export var white = "_1u-3";